import styled from 'styled-components';
import { Flex } from 'utils/style';

import RelativeDatePicker from 'components/form/RelativeDatePicker/container';

export default styled(RelativeDatePicker)`
  ${Flex.row};
  background: #ffffff;
  width: 100%;
  max-width: 100%;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  position: relative;
`;
